import Phaser from 'phaser';
import { PlatformVariants } from '../constants/PlatformVariants';
import { getEventEmitter } from "../services/EventService";

export default class Platform extends Phaser.Physics.Arcade.Sprite {

    /** @type {PlatformVariants} */
    variant;

    /** @type {Phaser.Physics.Arcade.Sprite} */
    player;

    /** @type {number} */
    velocityX = 0;

    /** @type {boolean} */
    isRotated = false;

    /**
     * 
     * @param {Game} scene 
     * @param {number} x 
     * @param {number} y 
     * @param {PlatformVariants} variant 
     * @param {Phaser.Physics.Arcade.Sprite} player
     */
    constructor(scene, x, y, variant, player) {

        super(scene, x, y, variant.texture);

        this.setScale(0.3);

        this.variant = variant;
        this.player = player;
    }

    addedToScene() {

        if (this.variant === PlatformVariants.BLANK) {
            this.disableBody(true, true);
        }

        if (this.variant !== PlatformVariants.BREAKING && this.variant !== PlatformVariants.SAW) {
            this.scene.physics.add.collider(this, this.player, this.handleCollider, this.processCollider);
        }

        if (this.variant === PlatformVariants.DYNAMIC) {
            this.velocityX = 3;
        }

        if (this.variant === PlatformVariants.SAW) {
            this.isRotated = true;
        }

        this.scene.physics.add.overlap(this, this.player, this.handleOverlap);
    }

    update() {

        // Rotate platform
        if (this.isRotated) {
            this.angle = this.angle + 5;
        }

        // Move platform
        if (this.velocityX !== 0) {
            this.x = this.x + this.velocityX;
            this.refreshBody();
        }

        // Reverse velocity if platform near screen edge
        if (this.x > this.scene.scale.width - 100 && this.velocityX > 0) {
            this.velocityX = -1 * this.velocityX;
        }
        if (this.x < 100 && this.velocityX < 0) {
            this.velocityX = -1 * this.velocityX;
        }
    }

    /**
     * 
     * @param {Platform} platform 
     * @param {Phaser.Physics.Arcade.Sprite} player 
     */
    handleCollider(platform, player) {

        // Auto jump for player
        if (player.body.onFloor()) {
            player.setVelocityY(-1270);
            player.setTexture('player_jump');
        }
    }

    /**
     * 
     * @param {Platform} platform 
     * @param {Phaser.Physics.Arcade.Sprite} player 
     */
    processCollider(platform, player) {

        // Collide if bottom of player near of top of platform
        if (Math.abs(platform.body.top - player.body.bottom) < 30) {
            return true;
        }
        // Otherwise not collide
        else {
            return false;
        }
    }

    /**
     * 
     * @param {Platform} platform 
     * @param {Phaser.Physics.Arcade.Sprite} player 
     */
    handleOverlap(platform, player) {

        // Disable breaking platform if player moving down
        if (platform.variant === PlatformVariants.BREAKING) {
            if (player.body.deltaY() > 0 && player.body.bottom < platform.body.bottom) {
                platform.disableBody(true, true);
            }
        }

        if (platform.variant === PlatformVariants.SAW) {
            getEventEmitter().emit("gameOver");
        }
    }

}